import { createContext } from 'react';

export const DocumentDispatchContext = createContext();
